/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
  GetListApiV1NotificationsFeedUserEventListGetQueryParams,
  GetListApiV1NotificationsFeedUserEventListGetHeaderParams,
  GetListApiV1NotificationsFeedUserEventListGet422,
} from '../../types/GetListApiV1NotificationsFeedUserEventListGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getListApiV1NotificationsFeedUserEventListGetQueryKey = (params?: GetListApiV1NotificationsFeedUserEventListGetQueryParams) =>
  [{ url: '/api/v1/notifications_feed_user_event/list/' }, ...(params ? [params] : [])] as const

export type GetListApiV1NotificationsFeedUserEventListGetQueryKey = ReturnType<typeof getListApiV1NotificationsFeedUserEventListGetQueryKey>

/**
 * @summary Get List
 * {@link /api/v1/notifications_feed_user_event/list/}
 */
export async function getListApiV1NotificationsFeedUserEventListGet(
  params?: GetListApiV1NotificationsFeedUserEventListGetQueryParams,
  headers?: GetListApiV1NotificationsFeedUserEventListGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
    ResponseErrorConfig<GetListApiV1NotificationsFeedUserEventListGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/notifications_feed_user_event/list/`, params, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function getListApiV1NotificationsFeedUserEventListGetQueryOptions(
  params?: GetListApiV1NotificationsFeedUserEventListGetQueryParams,
  headers?: GetListApiV1NotificationsFeedUserEventListGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getListApiV1NotificationsFeedUserEventListGetQueryKey(params)
  return queryOptions<
    GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
    ResponseErrorConfig<GetListApiV1NotificationsFeedUserEventListGet422>,
    GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getListApiV1NotificationsFeedUserEventListGet(params, headers, config)
    },
  })
}

/**
 * @summary Get List
 * {@link /api/v1/notifications_feed_user_event/list/}
 */
export function useGetListApiV1NotificationsFeedUserEventListGet<
  TData = GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
  TQueryData = GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
  TQueryKey extends QueryKey = GetListApiV1NotificationsFeedUserEventListGetQueryKey,
>(
  params?: GetListApiV1NotificationsFeedUserEventListGetQueryParams,
  headers?: GetListApiV1NotificationsFeedUserEventListGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
        ResponseErrorConfig<GetListApiV1NotificationsFeedUserEventListGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getListApiV1NotificationsFeedUserEventListGetQueryKey(params)

  const query = useQuery(
    {
      ...getListApiV1NotificationsFeedUserEventListGetQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetListApiV1NotificationsFeedUserEventListGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}